import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import {
  getloanAdvanceData,
  getprojectInchargeSummary,
} from "../../../../store/Api";

export default function EmployeePayment({
  setShowPromptElement,
  showPromptElement,
  popUpData,
  amountRequested,
  onSubmission,
  refreshData,
}) {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [documentAmount, setDocumentAmount] = useState();
  const [amount, setAmount] = useState();
  const [checked, setChecked] = useState(false);
  const [finalCheckbox, setFinalCheckbox] = useState(false);
  const [docStatus, setDocStatus] = useState("");

  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");

  const resetState = () => {
    setFile(null);
    setDocumentAmount("");
    setAmount("");
    setChecked(false);
    setFinalCheckbox(false);
    setLoading(false);
    setDocStatus("");
  };

  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  const handleDocumentAmountChange = (event) => {
    setDocumentAmount(event.target.value);
  };

  const handleFinalCheckboxChange = () => {
    setFinalCheckbox(!finalCheckbox);
    if (!finalCheckbox) {
      setChecked(false);
    }
  };

  const handleCheckboxChange = () => {
    setChecked(!checked);
    setDocumentAmount(0);
    setAmount(0);
    if (!checked) {
      setChecked(true);
    }
  };

  const submitHandler = async (e, fileData) => {
    e.preventDefault();
    if (finalCheckbox) {
      let finalAmount = parseInt(documentAmount) + parseInt(amount);
      if (parseInt(popUpData.loan_advance) !== parseInt(finalAmount)) {
        dispatch(
          setAppError({
            msg: "Amount mismatched",
          })
        );
        return;
      }
    } else if (checked) {
      if (parseInt(popUpData.loan_advance) !== parseInt(amount)) {
        dispatch(
          setAppError({
            msg: "Cash amount mismatched",
          })
        );
        return;
      }
    } else if (parseInt(popUpData.loan_advance) !== parseInt(documentAmount)) {
      dispatch(
        setAppError({
          msg: "Document amount mismatched",
        })
      );
      return;
    }
    console.log("file to be seen here..........file.....",file)
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("cash_receipt_amount", amount ? amount : 0);
      formData.append("document_receipt_amount", documentAmount);
      formData.append(
        "employee_cash_status",
        amount <= 0 && documentAmount > 0
          ? "DOCUMENT RECEIVED"
          : documentAmount > 0 && amount > 0
            ? "DOC & CASH RECEIVED"
            : checked || finalCheckbox
              ? "CASH RECEIVED"
              : ""
      );
      formData.append("amount_requested", parseInt(popUpData.loan_advance));
      formData.append("candidate_flight_id", amountRequested.id);

      const response = await nodeinstance.post(
        `/dashboard/loanAdvance/addEmp/${popUpData?.employee_id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        resetState();
        setShowPromptElement(false);
        dispatch(
          setAppError({
            msg: "Successfully uploaded.",
            color: "success",
          })
        );
        dispatch(getloanAdvanceData(token));
        dispatch(getprojectInchargeSummary(token));
        onSubmission(!refreshData);
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  useEffect(() => {
    setDocumentAmount(popUpData?.document_receipt_amount || 0);
    setAmount(popUpData?.cash_receipt_amount || 0);
    setDocStatus(popUpData?.employee_cash_status || "");
  }, [popUpData]);

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
        showPromptElement ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-lg w-full h-auto rounded-md bg-white/95 flex flex-col p-4 relative">
        <div className="flex justify-between items-center w-full">
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              resetState();
              setShowPromptElement(false);
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
          <div className="w-full flex flex-col gap-3 my-3 p-5">
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Upload File</span>
              </label>
              {/* <input
                type="file"
                className="file-input file-input-bordered w-full"
                onChange={(e) => setFile(e.target.files[0])}
                required={popUpData?.document ? false : true}
                disabled={
                  finalCheckbox === "CASH RECEIVED" ||
                  checked === "CASH RECEIVED"
                }
                accept="image/*, application/doc, application/docx, application/pdf, application/xls, application/xlsx"
              /> */}

              <input
                type="file"
                className="file-input file-input-bordered w-full"
                onChange={(e) => setFile(e.target.files[0])}
                required={!checked}
                // disabled={checked}
                accept="image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />

              {(popUpData?.document && file === undefined) || file === null ? (
                <div>Existing file: {popUpData?.document}</div>
              ) : (
                ""
              )}
            </div>
            <div className="flex flex-col p-2 gap-1 w-full max-w-md">
              <label htmlFor="checkbox" className="text-xs ml-3">
                DOCUMENT RECEIPT AMOUNT
              </label>
              <input
                type="number"
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                onChange={handleDocumentAmountChange}
                value={documentAmount}
                disabled={checked}
              />
            </div>
            <div className="flex flex-col p-2 gap-1 w-full max-w-md">
              <label htmlFor="checkbox" className="text-xs ml-3">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                CASH RECEIVED
              </label>
              <input
                type="number"
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                onChange={handleAmountChange}
                value={amount}
                disabled={!checked && !finalCheckbox}
              />
            </div>
            <div className="flex flex-col p-2 gap-1 w-full max-w-md">
              <label htmlFor="checkbox" className="text-xs ml-3">
                <input
                  type="checkbox"
                  checked={finalCheckbox}
                  onChange={handleFinalCheckboxChange}
                  className="mr-2"
                />
                ENABLE BOTH OPTIONS
              </label>
            </div>
            <div className="flex gap-3 w-full justify-center" style={{ m: 2 }}>
              <button
                type="submit"
                className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
              >
                <p>Submit</p>
                {loading ? <CgSpinner className="animate-spin" /> : ""}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
